<template>
    <div>
        <el-dialog
            :visible.sync="holidayDetail.show"
            width="40%"
            append-to-body
            :show-close="false"
            :close-on-click-modal="false"
            class="booking-calendar-curier-more-detail-kan-style"
        >
        <el-form :model="holiday" ref="holiday">
            <el-row>
                <el-col :span="8" :offset="8" class="text-center">
                    <h2>{{ holidayDetail.isEdit ? 'แก้ไขวันหยุด':'เพิ่มวันหยุด'}}</h2>
                </el-col>
                <el-col v-if="holidayDetail.isEdit" :span="8" class="text-right">
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link d-font-icon">
                            <i class="material-icons" style="font-size: 30px;">more_vert</i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-delete-solid" @click.native="deleteHolidayHandler()">ลบ</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <span>ชื่อวันหยุด :</span>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        prop="name"
                        :rules="[ { required: true, message: 'กรุณากรอกชื่อวันหยุด', trigger: 'blur' } ]"
                    >
                        <el-input placeholder="โปรดใส่ชื่อวันหยุด" v-model="holiday.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6" style="padding-left: 10px;">
                    <el-form-item
                        prop="date"
                        :rules="[ { required: true, message: 'กรุณาเลือกวัน', trigger: 'change' } ]"
                    >
                        <el-date-picker
                            v-model="holiday.date"
                            :disabled="holidayDetail.isEdit"
                            :picker-options="datePickerOptions"
                            class="booking-calendar-holiday-dialog-date-picker-kan-style"
                            :clearable="false"
                            type="date"
                            placeholder="Pick a day">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <span>ขนส่งหยุด :</span>
                </el-col>
                <el-col :span="18">
                    <el-form-item
                        prop="courierId"
                        :rules="[ { required: true, message: 'กรุณาเลือกขนส่ง', trigger: 'change' }]"
                    >
                    <el-checkbox-group v-model="holiday.courierId">
                        <el-row v-for="item in courierNameArray" :key="item.id">
                            <el-col :span="24" class="text-left" style="padding-left: 10px;">
                                <el-checkbox
                                    class="booking-calendar-courier-checkbox-kan-style"
                                    :label="item.courierId"
                                    :style=" `--tooltip-color: ${item.color};`"
                                    type="error"
                                >{{item.label}}</el-checkbox>
                            </el-col>
                        </el-row>
                    </el-checkbox-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="text-center">
                    <el-form-item>
                        <el-button outline class="booking-calendar-holiday-actions-btn-kan-style" @click="resetForm('holiday')">ยกเลิก</el-button>
                        <el-button type="primary" class="booking-calendar-holiday-actions-btn-kan-style" @click="submitForm('holiday')">บันทึก</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        </el-dialog>
        <el-dialog
            title="ยืนยันการลบ"
            class="booking-calendar-delete-holiday-dialog-kan-style"
            center
            :visible.sync="deleteHoliday.show"
            width="40%"
            append-to-body
            :show-close="false"
            :close-on-click-modal="false"
        >
        <el-form :model="deleteHoliday" ref="deleteConfrim">
            <el-row>
                <el-col :span="24" class="text-center">
                    <span class="font-sarabun-kan-style booking-calendar-holiday-text-kan-style">กรุณาใส่รหัสผ่านเพื่อยืนยันการลบวันหยุด</span>
                </el-col>
                <el-col :span="16" :offset="4" style="padding-top: 15px; padding-bottom: 210px;">
                    <el-form-item
                        prop="deletePassword"
                        :rules="[
                            { required: true, message: 'กรุณากรอกรหัสผ่าน', trigger: 'blur' },
                            { min:6, message: 'จำเป็นต้องมีมากกว่า 6 ตัวอักษร', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            v-model="deleteHoliday.deletePassword"
                            type="password"
                            placeholder="กรุณากรอกรหัสผ่าน"
                            show-password
                            auto-complete="new-password">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="text-center">
                    <el-form-item>
                        <el-button outline class="booking-calendar-holiday-actions-btn-kan-style" @click="cancleDeleteHoliday('deleteConfrim')">ยกเลิก</el-button>
                        <el-button type="primary" class="booking-calendar-holiday-actions-btn-kan-style" @click="submitDeleteHoliday('deleteConfrim')">ตกลง</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

// pathify
import { sync, call } from 'vuex-pathify'

export default {
    name: 'BookingCalendarCourierDetailDialog',
    props: {
        holidayDetail: {
            type: Object,
            default: () => {
                return {
                    holidayId: '',
                    isEdit: false,
                    info: [],
                    holidayName: '',
                    holidayDate: '',
                    show: false,
                    holidayArray: []
                }
            }
        }
    },
    data () {
        return {
            holiday: {
                name: '',
                date: '',
                courierId: []
            },
            deleteHoliday: {
                show: false,
                deletePassword: ''
            },
            holidayPick: '',
            courierHolidayDate: '',
            password: '',
            courierNameArray: [
                { id: 0, courierId: 1, label: 'SCG Express', color: '#08A7A3' },
                { id: 1, courierId: 4, label: 'Flash Express', color: '#F9EC00' },
                { id: 2, courierId: 10, label: 'Bee Express', color: '#FFAA00' },
                { id: 3, courierId: 9, label: 'Best Express', color: '#FC5C5C' }
            ],
            datePickerOptions: {
                disabledDate: (date) => {
                    if (date < this.$dayjs(new Date()).subtract(1, 'day')) {
                        return date < this.$dayjs(new Date()).subtract(1, 'day')
                    } else {
                        return this.holidayDetail.holidayArray.some(e => e === this.$dayjs(date).format('YYYY-MM-DD'))
                    }
                }
            }
        }
    },
    computed: {
        ...sync('booking/*')
    },
    watch: {
        'deleteHoliday.show' (status) {
            if (status) {
                this.$nextTick(() => {
                    this.$refs['deleteConfrim'].resetFields()
                })
            } else {
                this.deleteHoliday = {
                    deletePassword: '',
                    show: false
                }
            }
        },
        'holidayDetail.show' (status) {
            if (status) {
                this.$nextTick(() => {
                    this.$refs['holiday'].resetFields()
                    this.holiday.courierId = this.holidayDetail.info
                    this.holiday.name = this.holidayDetail.holidayName
                    this.holiday.date = this.holidayDetail.holidayDate
                })
            } else {
                this.holiday = {
                    name: '',
                    date: '',
                    courierId: [],
                    password: ''
                }
            }
        }
    },
    methods: {
        ...call('booking/*'),
        deleteHolidayHandler () {
            this.deleteHoliday.show = true
        },
        submitForm (formName) {
            try {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let validatePassword = (input) => {
                            if (input === '123456') {
                                return true
                            }
                            return 'รหัสผ่านไม่ถูกต้อง'
                        }
                        this.$prompt('', 'ยืนยันรหัส', {
                            confirmButtonText: 'ยืนยัน',
                            cancelButtonText: 'ยกเลิก',
                            inputType: 'password',
                            inputValidator: validatePassword
                        }).then(async ({ value }) => {
                            if (this.holidayDetail.isEdit) {
                            // Edit Holiday
                                let param = {
                                    name: this.holiday.name,
                                    date: this.$dayjs(this.holiday.date).format('YYYY-MM-DD'),
                                    courier_ids: this.holiday.courierId,
                                    courier_holiday_id: this.holidayDetail.holidayId
                                }
                                let res = await fgApi.courier.updateHolidayBookingCalendar(param)
                                if (res.success) {
                                    this.bookingCalendarObj.loading = true
                                    this.holidayDetail.show = false
                                    this.$message.success('แก้ไขวันหยุดสำเร็จ!!')
                                    await this.fetchCalendarEventInfo()
                                    this.bookingCalendarObj.loading = false
                                } else {
                                    this.$message.warning('แก้ไขวันหยุดไม่สำเร็จ!!')
                                }
                            } else {
                            // Create Holiday
                                let param = {
                                    name: this.holiday.name,
                                    date: this.$dayjs(this.holiday.date).format('YYYY-MM-DD'),
                                    courier_ids: this.holiday.courierId
                                }
                                let res = await fgApi.courier.createHolidayBookingCalendar(param)
                                if (res.success) {
                                    this.bookingCalendarObj.loading = true
                                    this.holidayDetail.show = false
                                    this.$message.success('สร้างวันหยุดสำเร็จ!!')
                                    await this.fetchCalendarEventInfo()
                                    this.bookingCalendarObj.loading = false
                                } else {
                                    this.$message.warning('สร้างวันหยุดไม่สำเร็จ!!')
                                }
                            }
                        }).catch(() => {
                            this.holidayDetail.show = false
                        })
                    } else {
                        // this.holidayDetail.show = true
                    }
                })
            } catch (error) {
                this.$message.error(`Oops, Api is ${error} !`)
            }
        },
        resetForm (formName) {
            this.$refs[formName].resetFields()
            this.holidayDetail.show = false
        },
        cancleDeleteHoliday (formName) {
            this.$refs[formName].resetFields()
            this.resetForm('holiday')
            this.deleteHoliday.show = false
        },
        submitDeleteHoliday (formName) {
            try {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        if (this.deleteHoliday.deletePassword === '123456') {
                            let param = this.holidayDetail.holidayId
                            let res = await fgApi.courier.deleteHolidayBookingCalendar(param)
                            if (res.success) {
                                this.bookingCalendarObj.loading = true
                                this.$message.success('ลบวันหยุดสำเร็จ!!')
                                await this.fetchCalendarEventInfo()
                                this.holidayDetail.show = false
                                this.deleteHoliday.show = false
                                this.bookingCalendarObj.loading = false
                            } else {
                                this.$message.warning('ลบวันหยุดไม่สำเร็จ!!')
                            }
                        } else {
                            this.$message.error('รหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่')
                        }
                    } else {
                        // this.deleteHoliday.show = true
                    }
                })
            } catch (error) {
                this.$message.error(`Oops, Api is ${error} !`)
            }
        }
    }
}
</script>
<style lang="scss">
    .booking-calendar-holiday-actions-btn-kan-style{
        max-width: 150px;
        min-width: 150px;
    }
    .booking-calendar-holiday-text-kan-style{
        color: #A0A0A0;
        font-size: 14px;
    }
    .booking-calendar-delete-holiday-dialog-kan-style{
        .el-dialog__header{
            border-bottom: 1px solid #D0DADC;
            .el-dialog__title{
                color: #2C3E50;
                font-family: Sarabun;
                font-size: 20px;
                font-weight: bold;
            }
        }
    }
    .booking-calendar-holiday-dialog-date-picker-kan-style{
        max-width: 40px;
        min-width: 40px;
        .el-input__prefix{
            i{
                font-size: 20px;
                padding-left: 16px;
            }
        }
    }
    .booking-calendar-curier-more-detail-kan-style{
        .el-dialog{
            .el-dialog__header{
                padding: 0;
            }
            // .el-dialog__body{
            //     padding: 0;
            // }
        }
    }
</style>
